import configHandler from '../configHandler'
import { getCountryCallingCode, parsePhoneNumber } from 'libphonenumber-js/max'
import extractCountryCallingCode from 'libphonenumber-js/source/helpers/extractCountryCallingCode'
import metadata from 'libphonenumber-js/max/metadata'

const INVALID_NUMBER = 'invalidNumber'

export const getDefaultCountryCodeRegion = () => {
    return configHandler.getPhoneIsoCodeRegion()
}

export const getDefaultCountryCode = () => {
    return getCountryCallingCode(getDefaultCountryCodeRegion())
}

export const getNationalPrefix = () => {
    // TODO: get national prefix from Metadata
    return '0'
}

const numberParser = (number) => {
    return {
        number: number,

        removeLeadingPlus: function () {
            if (String(this.number).charAt(0) === '+') {
                // Remove + from supplied number
                this.number = this.number.substring(1)
            }
            return this
        },

        removeLeadingZero: function () {
            if (String(this.number).charAt(0) === getNationalPrefix()) {
                // Remove + from supplied number
                this.number = this.number.substring(1)
            }
            return this
        },

        extractCountryCode: function () {
            return extractCountryCallingCode(number, getDefaultCountryCodeRegion(), null, metadata)
        },

        extractCountryCodeWithLeadingPlus: function () {
            return extractCountryCallingCode('+' + number, getDefaultCountryCodeRegion(), null, metadata)
        },

        getNumber: function () {
            return this.number
        },
    }
}

export const parse = (inputNumber, inputCountryCode) => {
    let defaultCountryCode = getDefaultCountryCode()

    // Sanitize input number
    const parser = numberParser(inputNumber)
        .removeLeadingPlus()
        .removeLeadingZero()

    let number = parser
        .getNumber()

    let countryCode = inputCountryCode

    if (countryCode === undefined || !countryCode) {
        const countryCallingObject = parser.extractCountryCode()

        // Set countryCode to extracted countryCode or default
        if (typeof countryCallingObject.countryCallingCode === 'string') {
            countryCode = countryCallingObject.countryCallingCode
            // Also overwrite number, as it may have been including cc before extraction
            number = countryCallingObject.number
        } else {
            countryCode = defaultCountryCode
        }
    }
    // Parse number with +{countryCode}{number}
    let parsedNumber
    try {
        parsedNumber = parsePhoneNumber('+' + countryCode + number)

        if (parsedNumber === undefined || !parsedNumber.isValid()) {
            // Failed to parse phone number. Can happen i countryCode is set on number without leading plus
            // Attempt to extract countryCode with leading plus and parsing the result if successful
            const countryCallingObjectWithLeadingPlus = parser.extractCountryCodeWithLeadingPlus()
            if (typeof countryCallingObjectWithLeadingPlus.countryCallingCode === 'string') {
                countryCode = countryCallingObjectWithLeadingPlus.countryCallingCode
                number = countryCallingObjectWithLeadingPlus.number
                parsedNumber = parsePhoneNumber('+' + countryCode + number)
            }
        }
    } catch (e) {
        if (configHandler.debug) {
            // Only print error if in debug mode
            console.error(e)
        }
    }

    return {
        inputNumber: inputNumber,
        inputCountryCode: inputCountryCode,
        number: number,
        countryCode: countryCode,
        parsedNumber: parsedNumber,
        errors: [],

        format: function () {
            if (!this.isValid()) {
                return inputNumber
            }

            if (this.parsedNumber.countryCallingCode === getCountryCallingCode(getDefaultCountryCodeRegion())) {
                return this.parsedNumber.formatNational()
            }
            return this.parsedNumber.formatInternational()
        },

        formatAsHTMLLink: function () {
            const formattedNumber = this.format()
            const parsedNumberWithCC = '+' + this.countryCode + this.number
            return '<a href="tel:' + parsedNumberWithCC + '">' + formattedNumber + '</a>'
        },

        isValid: function () {
            // Is valid if there are no errors
            return this.validate().length === 0
        },

        validate: function () {
            this.errors = []
            if (this.parsedNumber === undefined || !this.parsedNumber.isValid()) {
                this.errors.push(configHandler.errorMessages().phone[INVALID_NUMBER])
            }

            return this.errors
        },

        input: function () {
            return {
                countryCode: this.inputCountryCode,
                number: this.inputNumber,
            }
        },
    }
}

export default {
    parse,
    getDefaultCountryCodeRegion,
    getDefaultCountryCode,
    getNationalPrefix,
}